export const STATIONS = '/api/station';
export const STATIONS_CATEGORY = '/api/station/category';
export const PROGRAMS = '/api/program';
export const PROGRAMS_CURRENT = '/api/program/current';
export const PROGRAMS_SEARCH = '/api/program/search';
export const PROGRAMS_ARTICLES = '/api/program/article';
export const PROGRAMS_TIPS = '/api/program/tip';
export const SEARCH_STATIONS = '/api/station/search';
